import '../styles/Viz.css'
function Viz({children}){
	return <div className="square">
				<div className="viz">{children}</div>
			</div>
}

export default Viz